// Client-side mirror of the server dedupe key: case, accents and extra
// whitespace are ignored, punctuation is kept ("C#" !== "C++"). Only used to
// detect "already in list" / "exists as X"; the server stays authoritative.
export const normalizeTagName = (name: string): string =>
  name
    .normalize('NFD')
    .replace(/[̀-ͯ]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLocaleLowerCase('es');
